var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaymanIslandsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_2845_1565)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.957 16.0001H15.9998C15.9998 15.9857 15.9998 15.9717 15.9998 15.9573C15.9856 15.9716 15.9713 15.9858 15.957 16.0001Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 11.8262C24.4933 11.8262 25.7391 10.5804 25.7391 9.04361C25.7391 7.50681 24.4933 6.26099 22.9565 6.26099C21.4197 6.26099 20.1738 7.50681 20.1738 9.04361C20.1738 10.5804 21.4197 11.8262 22.9565 11.8262Z",
    fill: "#6DA544"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09466 2.08691C5.59223 3.51185 3.51179 5.59223 2.08691 8.09466V16H6.26085V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09466Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 14.0325L10.3152 8.3479H8.34766V8.34803L15.9997 16H15.9998C15.9998 16 15.9998 14.6433 15.9998 14.0325Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 8.3479H27.826V12.5218H18.0869V8.3479Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 18.7827V21.5653H19.5509C20.4287 22.4256 21.6303 22.9567 22.9565 22.9567C24.2827 22.9567 25.4842 22.4256 26.362 21.5653H26.4347H27.826V18.7827H18.0869Z",
    fill: "#FFDA44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 11.8262V16.0001C18.0869 19.7275 22.9565 20.8697 22.9565 20.8697C22.9565 20.8697 27.826 19.7275 27.826 16.0001V11.8262H18.0869Z",
    fill: "#338AF3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 14.0557C21.7389 14.0557 21.7389 15.1687 20.5215 15.1687C19.3042 15.1687 19.3042 14.0557 18.0869 14.0557V16.0035C19.3042 16.0035 19.3042 17.1165 20.5215 17.1165C21.7389 17.1165 21.7389 16.0035 22.9562 16.0035C24.1736 16.0035 24.1736 17.1165 25.3911 17.1165C26.6086 17.1165 26.6085 16.0035 27.826 16.0035V14.0557C26.6086 14.0557 26.6086 15.1687 25.3911 15.1687C24.1736 15.1687 24.1736 14.0557 22.9562 14.0557Z",
    fill: "#F3F3F3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 10.1565C21.7389 10.1565 21.7389 11.2696 20.5215 11.2696C19.3042 11.2696 19.3042 10.1565 18.0869 10.1565V12.1043C19.3042 12.1043 19.3042 13.2174 20.5215 13.2174C21.7389 13.2174 21.7389 12.1043 22.9562 12.1043C24.1736 12.1043 24.1736 13.2174 25.3911 13.2174C26.6086 13.2174 26.6085 12.1043 27.826 12.1043V10.1565C26.6086 10.1565 26.6086 11.2696 25.3911 11.2696C24.1736 11.2696 24.1736 10.1565 22.9562 10.1565Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2845_1565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaymanIslandsFlag);
export default __webpack_public_path__ + "static/media/cayman-islands-flag.3d29c177b08310bfa9a8e6ba2cd653f4.svg";
export { ForwardRef as ReactComponent };